/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Carrier_LabelInputs */

const vi_order_form_carrier_label = /** @type {(inputs: Order_Form_Carrier_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị vận chuyển`)
};

/**

* @param {Order_Form_Carrier_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_carrier_label = /** @type {((inputs?: Order_Form_Carrier_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Carrier_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_carrier_label(inputs)
});